namespace $ {
	
	export var $mol_dom_context : typeof globalThis
	
}
